import { AvvirEvent } from "type_aliases";
import { ApiProjectSupportingSignals } from "avvir";

export type ProjectSupportingSignalsLoadedEvent = AvvirEvent<typeof PROJECT_SUPPORTING_SIGNALS_LOADED, {
  projectId: string;
  supportingSignals: ApiProjectSupportingSignals;
}>

const projectSupportingSignalsLoaded = (projectId: string, supportingSignals: ApiProjectSupportingSignals): ProjectSupportingSignalsLoadedEvent => ({
  type: PROJECT_SUPPORTING_SIGNALS_LOADED,
  payload: {
    projectId,
    supportingSignals
  }
});

export const PROJECT_SUPPORTING_SIGNALS_LOADED = "project_supporting_signals_loaded";

export default projectSupportingSignalsLoaded;
